import { BookOpen, CalendarDays, Clock, FileSpreadsheet, FileText, HardHat, ReceiptEuro, Settings, ShieldCheck, Users, type LucideIcon } from 'lucide-react'

export type Entree = {
  to: string
  titre: string
  description: string
  Icone: LucideIcon
  /** Fond de la pastille d'icône (texte blanc : nuances 600 à 700, contraste suffisant) */
  couleur: string
  /** Réservée au propriétaire de l'entreprise */
  proprietaire?: boolean
}

/** Écrans de l'artisan, dans l'ordre de la grille d'accueil. Devis, Clients et Chantiers sont aussi dans la barre d'onglets. */
export const ENTREES: Entree[] = [
  { to: '/devis', titre: 'Devis', description: 'Créer et gérer vos devis', Icone: FileText, couleur: 'bg-blue-600' },
  { to: '/clients', titre: 'Clients', description: 'Voir et gérer vos clients', Icone: Users, couleur: 'bg-green-600' },
  { to: '/chantiers', titre: 'Chantiers', description: 'Suivre vos chantiers', Icone: HardHat, couleur: 'bg-orange-600' },
  { to: '/heures', titre: 'Heures de la semaine', description: 'Pointer vos heures', Icone: Clock, couleur: 'bg-purple-600' },
  { to: '/planning', titre: 'Planning', description: 'Tâches de la semaine', Icone: CalendarDays, couleur: 'bg-teal-600' },
  { to: '/bibliotheque', titre: 'Ma bibliothèque', description: 'Vos ouvrages et articles', Icone: BookOpen, couleur: 'bg-pink-600' },
  { to: '/impayes', titre: 'Impayés', description: 'Factures à encaisser', Icone: ReceiptEuro, couleur: 'bg-slate-700' },
  { to: '/donnees', titre: 'Import / export Excel', description: 'Importer ou exporter vos données', Icone: FileSpreadsheet, couleur: 'bg-blue-800' },
  { to: '/reglages', titre: 'Réglages entreprise', description: 'Infos et préférences', Icone: Settings, couleur: 'bg-indigo-600', proprietaire: true },
  { to: '/compte', titre: 'Compte et sécurité', description: 'Gérer votre compte', Icone: ShieldCheck, couleur: 'bg-green-700' },
]

/** Entrées qui ont déjà leur onglet : « Plus » liste les autres. */
const AVEC_ONGLET = new Set(['/devis', '/clients', '/chantiers'])
export const ENTREES_PLUS = ENTREES.filter((e) => !AVEC_ONGLET.has(e.to))
